import React, { Component } from 'react';
import { imageBasePath, appBasePath, metaTagData, canonicalLink } from '../../constants/staticData';
import { Link } from 'react-scroll';
import { Helmet } from "react-helmet";

export default class BusinessLandingHeader extends Component {
  constructor(props) {
    super(props);
    this.openMobileTab = this.openMobileTab.bind(this);
    this.state = {
      collapsible: false
    };
  }

  componentWillMount() { }

  componentWillUnmount() { }
  openMobileTab() {
    this.setState({ collapsible: !this.state.collapsible });
  }

  render() {
    // const active = this.props.activeLink ? 'active' : '';
    const baseUrl = location.origin;
    const { metaTagKey } = this.props;
    return (
      <div className="">
        {metaTagData ? <Helmet>
          <meta charSet="utf-8" />
          <title>{metaTagData[metaTagKey] && metaTagData[metaTagKey].title ? metaTagData[metaTagKey].title : 'Carcility Business'}</title>
          <meta name="description" content={metaTagData[metaTagKey] && metaTagData[metaTagKey].description ? metaTagData[metaTagKey].description : ''} />
          <link rel="canonical" href={canonicalLink} />
        </Helmet> : ''}
        <header>
          <div className="custom-menu">
            <div className="container-fluid">
              <div className="row">
                <div className="navbar-custom">
                  <nav className="navbar navbar-default" role="navigation">
                    <div className="navbar-header">
                      <button
                        type="button"
                        className="navbar-toggle"
                        data-toggle="collapse"
                        data-target="#menu-navbar-collapse"
                        onClick={() => this.openMobileTab()}
                      >
                        <span className="sr-only">&nbsp;</span>
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                      </button>
                      <div
                        className="navbar-brand desk-logo"
                        onClick={() => location.href = baseUrl}
                      >
                        <img src={`${imageBasePath}/car-service-dubai-carcility-logo.svg`} alt="Car service dubai carcility logo" />
                      </div>
                      <div
                        className="navbar-brand mobile-logo"
                        onClick={() => location.href = baseUrl}
                      >
                        <img src={`${imageBasePath}/car-service-dubai-carcility-logo.svg`} alt="Car service dubai carcility logo" />
                      </div>
                      <div className="clear-direction" />
                    </div>
                    <div
                      id="menu-navbar-collapse"
                      className={this.state.collapsible ? '' : 'collapse navbar-collapse'}
                    >
                      <ul className="nav navbar-nav navbar-right">
                        <li className="">
                          <div>
                            <Link to="how-works" smooth={true} duration={600}>
                              How It Works
                                                        </Link>
                          </div>
                        </li>
                        <li>
                          <div onClick={() => window.location.pathname = '/'}>
                            For Customers
                                                    </div>
                        </li>
                        <li>
                          <div
                            href=""
                            onClick={() =>
                              window.location.pathname = '/blog'}
                          >
                           BLOG
                                                    </div>
                        </li>
                        <li>
                          <div
                            href=""
                            onClick={() =>
                              window.location.pathname = '/business/sign-in'}
                          >
                            Log In
                                                    </div>
                        </li>
                        <li>
                          <div
                            onClick={() =>
                              window.location.pathname = 'business/sign-up'}
                          >
                            Sign Up
                                                    </div>
                        </li>
                      </ul>
                      <div className="clear-direction" />
                    </div>
                    <div className="clear-direction" />
                  </nav>
                  <div className="clear-direction" />
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BusinessLanding/BusinessLandingHeader.jsx